import { writable, readable } from 'svelte/store';

export let pipelineObserver = writable();
export let waitingOrRunningPipelineIds = writable([]);
export let allPipelines = writable([]);
export let availableSessions = writable([]);
export let sessionsPageSize = readable(25);
export let sessionsSkip = writable(0);
export let availableSessionsTotalCount = writable(0);
export let isSessionsListLegacy = writable(false); // Legacy support for unpaged list. Can be removed when all backends updated.
export let isSessionsListLoading = writable(false);
export let isPipelinesListLoading = writable(false);
export let sessionFilter = writable({userIds:[], teamIds:[], sortOrder:""});